module.exports = {"id":"dp3_2l3q1","text":"Integrating and re-elaborating digital content","instructions":"Which approach best demonstrates purposeful digital content integration?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"3.2","questionType":"PickOne","random":true,"options":[{"id":"dp3_2l3q1-a1","text":"Selecting formats that suit the content purpose","score":3.7},{"id":"dp3_2l3q1-a2","text":"Combining content without considering structure","score":1.3},{"id":"dp3_2l3q1-a3","text":"Reusing content exactly as originally created","score":1.3}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat3.2/l3q1.json
// module id = 1135
// module chunks = 41